import { FC, useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Link as ScrollLink } from 'react-scroll'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

import imgArticles from '../../assets/images/selection/static/articles.jpg'
import imgCollections from '../../assets/images/selection/static/collections.jpg'
import { articleCards } from '../../consts/articlesCards'
import { collectionsData } from '../../consts/collectionPageData'
import { DataProps } from '../../pages/NewCollectionsPage/NewCollectionPage.types'
import { fullPadeCardClick, investCardClick } from '../Analytics/Analytics'
import { BriefcaseOrange } from '../icons/BriefcaseOrange'
// import { Briefcase } from '../icons/Briefcase'
import { BriefcaseViolet } from '../icons/BriefcaseViolet'
import { MapPoint } from '../icons/MapPoint'
import style from './MainTable.module.scss'
import { MainTableCards } from './MainTableCards'
import { CollectionCard } from './MainTableItems'

function getRandomCollections(collections: DataProps[], count: number) {
  const randomCollections = []
  const usedIndices = new Set<number>()

  while (randomCollections.length < count) {
    const randomIndex = Math.floor(Math.random() * collections.length)
    if (!usedIndices.has(randomIndex)) {
      usedIndices.add(randomIndex)
      randomCollections.push(collections[randomIndex])
    }
  }

  return randomCollections
}

const popularItems: DataProps[] = []
const infrastructureItems: DataProps[] = []
const locationItems: DataProps[] = []

collectionsData.collections.forEach(collection => {
  if (collection.disable) return

  if (collection.category === 'popular') {
    popularItems.push(collection)
  } else if (collection.category === 'infrastructure') {
    infrastructureItems.push(collection)
  } else if (collection.category === 'location') {
    locationItems.push(collection)
  }
})

const tableData = [
  {
    category: {
      type: 'popular',
      label: 'Популярное',
      selection: 3,
    },
    items: {
      mainCollection: collectionsData.collections[94 - 1],
      mainArticle: articleCards[0],
      collections: getRandomCollections(popularItems, 3),
    },
  },
  {
    category: {
      type: 'infrastructure',
      label: 'По инфраструктуре',
      selection: 2,
    },
    items: {
      mainCollection: collectionsData.collections[10 - 1],
      mainArticle: articleCards[5],
      collections: getRandomCollections(infrastructureItems, 3),
    },
  },
  {
    category: {
      type: 'location',
      label: 'По местоположению',
      selection: 1,
    },
    items: {
      mainCollection: collectionsData.collections[6 - 1],
      mainArticle: articleCards[2],
      collections: getRandomCollections(locationItems, 3),
    },
  },
]

const tabIndexs: { [key: string]: number } = {}

tableData.forEach((item, index) => {
  tabIndexs[item.category.type] = index
})

const investAnalytics = () => {
  investCardClick('middle')
}

const fullPageAnalytics = (type: string) => {
  fullPadeCardClick(type)
}

export const MainTable: FC = () => {
  const tabsRef = useRef<HTMLDivElement>(null)
  const { hash } = useLocation()
  const [activeTab, setActiveTab] = useState<number>(0)

  const onSelect = (index: number) => {
    setActiveTab(index)
    let newHash = ''

    for (const key in tabIndexs) {
      if (tabIndexs[key] === index) {
        newHash = key
      }
    }

    location.hash = newHash
  }

  const updateTabs = () => {
    const curTab: any = tabsRef.current?.childNodes[0].childNodes[activeTab]

    if (curTab && tabsRef.current) {
      tabsRef.current.scrollTo({
        left: curTab.offsetLeft,
        behavior: 'smooth',
      })
    }

    document.dispatchEvent(new Event('tab-change'))
  }

  const tabChange = () => {
    if (!hash) return

    const currentTab = hash.slice(1)
    setActiveTab(tabIndexs[currentTab])
  }

  useEffect(updateTabs, [activeTab])

  useEffect(() => {
    tabChange()
  }, [hash])

  return (
    <div className={style.container}>
      <div className={style['table-header']}>
        <Tabs
          onSelect={onSelect}
          forceRenderTabPanel={true}
          selectedIndex={activeTab}
          selectedTabPanelClassName={style.active}
          selectedTabClassName={style['tab__button--active']}
        >
          {/* tab button */}
          <div className={style.overflow} ref={tabsRef}>
            <TabList className={style.tabs}>
              {tableData.map((tab, index) => (
                <Tab key={index} className={style.tab__button}>
                  <span>{tab.category.label}</span>
                  <span>{tab.category.label}</span>
                </Tab>
              ))}
            </TabList>
          </div>

          {/* tab content */}
          <div className={style.tab__wraper}>
            {tableData.map((content, index) => (
              <TabPanel className={style.tab__content} key={index}>
                <MainTableCards
                  mainCollection={content.items.mainCollection}
                  mainArticle={content.items.mainArticle}
                  collections={content.items.collections}
                />
              </TabPanel>
            ))}
          </div>
        </Tabs>

        <ScrollLink
          smooth={true}
          to='#newBuildings'
          className={`${style['button-map']} for-desktop`}
        >
          <MapPoint />
          <span>Карта</span>
        </ScrollLink>
      </div>

      <div className={style.bottom}>
        <Link
          className={[style.item].join(' ')}
          to='/invest'
          onClick={investAnalytics}
        >
          <div
            className={[
              style.item__wrapper,
              style['item--invest'],
              style['item--visible'],
              style['item--orange'],
            ].join(' ')}
          >
            <div>
              <BriefcaseOrange />
            </div>
            <div className={style.item__content}>
              <span>Для инвестиций</span>
            </div>
          </div>
          <div
            className={[
              style.item__wrapper,
              style['item--invest'],
              style['item--shadow'],
              style['item--orange'],
            ].join(' ')}
          >
            <div>
              <BriefcaseOrange />
            </div>
            <div className={style.item__content}>
              <span>Для инвестиций</span>
            </div>
          </div>
        </Link>
        <CollectionCard
          id=''
          anonce={{ title: 'Все подборки', imagePath: imgCollections }}
          onClick={() => fullPageAnalytics('Все подборки')}
        />
        <CollectionCard
          id=''
          linkСategories='articles'
          anonce={{ title: 'Все статьи', imagePath: imgArticles }}
          onClick={() => fullPageAnalytics('Все статьи')}
        />
      </div>
    </div>
  )
}
